import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/call-time")({
	component: CallTimeLayout,
});

// In-page sub-nav removed (product, 2026-05-19). Call Session + Manage List
// were already collapsed into the single Call List view, and the "Results"
// tab is deprecated for now (see _.call-time.results.tsx). Call Time is now
// a single screen — header + the call list — with no in-page nav layer.
//
// Layout note: this route renders as plain document flow and relies on the
// _app shell's scroll container (`<div class="flex-1 overflow-auto">` around
// the Outlet) to handle vertical scrolling. We deliberately do NOT impose a
// local `h-full` + nested `overflow` here: `h-full` is `height:100%`, which
// Safari refuses to resolve against the shell's flex-item parent (it treats
// the parent height as `auto`), so the page sized to content and never
// scrolled. Keeping this plain-flow lets one scroll container (the shell,
// sized via `flex-1` — Safari-safe) own scrolling cross-browser.
function CallTimeLayout() {
	return (
		<div>
			<div className="px-6 pt-6">
				<h1 className="text-2xl font-bold tracking-tight">Call Time</h1>
				<p className="text-muted-foreground">
					Work your prioritized call list and log every outcome.
				</p>
			</div>

			<Outlet />
		</div>
	);
}
